/**
 * Application-wide constants
 * 
 * This file contains all constants used throughout the application to avoid
 * hard-coded values and make maintenance easier.
 */

export const AUTH_CONSTANTS = {
  // Token-related constants using simple localStorage keys
  TOKEN_STORAGE_KEY: 'jwt_token',
  USER_STORAGE_KEY: 'currentUser',
  
  // Session expiration thresholds (in seconds)
  SESSION_EXPIRING_THRESHOLD: 30,  // Show warning when less than 30 seconds remain
  TOKEN_RENEWAL_THRESHOLD: 300,    // Consider renewing token when less than 5 minutes remain
  MIN_TOKEN_EXPIRY_DIFF_SECONDS: 30, // Minimum difference in token expiry time to reset timer
  
  // Routes that don't require authentication
  AUTH_EXEMPT_ROUTES: ['/login', '/magiclink', '/book/candidate'],
  
  // Timeouts
  LOGOUT_DELAY_MS: 2000,           // Delay before logout after certain operations
  INACTIVITY_TIMEOUT_MS: 4 * 60 * 60 * 1000,  // Auto-logout after 4 hours of inactivity
  
  // Logging style constants
  LOG_STYLES: {
    INFO: 'color: #2E8B57;',
    WARNING: 'color: #FFA500;',
    ERROR: 'color: #FF0000;',
    AUTH: 'color: #4B0082;',
    TOKEN: 'color: #800080;',
    ADMIN: 'color: #ff00ff;'
  }
};

export const API_CONSTANTS = {
  // API endpoints
  AUTH_ENDPOINTS: {
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    MAGIC_LINK: '/auth/magic-link',
    REQUEST_MAGIC_LINK: '/auth/request-magic-link',
    REGISTER: '/auth/register',
    REQUEST_CODE: '/auth/request-code',
    VALIDATE_CODE: '/auth/validate-code',
    VALIDATE_TOKEN: '/auth/validate-token',
    REFRESH_TOKEN: '/auth/refresh-token',
    LOGOUT: '/auth/logout',
    VERSION: '/api/version',
    HEALTH: '/api/health',
    CANDIDATE_BOOKING: '/api/candidate/booking',
    SMS_WEBHOOK: '/api/webhooks/sms',
    SMS_WEBHOOK_HEALTH: '/api/webhooks/sms/health',
    SMS_WEBHOOK_TELNYX: '/api/webhooks/sms/telnyx'
  },
  
  // HTTP headers
  HEADERS: {
    AUTHORIZATION: 'Authorization',
    RENEWED_TOKEN: 'X-Renewed-Token'
  }
};

export const UI_CONSTANTS = {
  // CSS classes
  ALERT_CLASSES: {
    SUCCESS: 'alert-success',
    DANGER: 'alert-danger',
    WARNING: 'alert-warning',
    INFO: 'alert-info'
  }
};
